import React from 'react';

export const Error = ({message, className}) => (
    <div className={className}>{message}</div>
)

export const RegularError = ({message}) => (
    <Error className="form__error" message={message} />
)

export const SmallError = ({message}) => (
    <Error className="form__error-small" message={message} />
)


// WEBPACK FOOTER //
// ./src/components/InputError/index.js